import { Socket } from 'socket.io-client';
import { ChatMessage, MessageType } from '../../../../types/chat.types';
import { WebSocketChatEvents } from '../../constants/webSocketChatEvents.constant';
import { WsErrorsEnum } from '../../constants/webSocketErrors.constants';

export type ClientSocket = Socket<ClientListenEvents, ClientEmitEvents>;

interface ClientEmitEvents {
  [WebSocketChatEvents.CONNECT_BRAND_NOTIFICATIONS]: () => void;
  [WebSocketChatEvents.CONNECT_STORE_NOTIFICATIONS]: () => void;
  [WebSocketChatEvents.JOIN_CHAT]: (payload: JoinChatPayload) => void;
  [WebSocketChatEvents.SEND_MESSAGE]: (payload: SendMessagePayload) => void;
  [WebSocketChatEvents.DISCONNECT_FROM_CHAT]: (payload: DisconnectFromChatPayload) => void;
}

interface ClientListenEvents {
  [WebSocketChatEvents.EXCEPTION]: (payload: ExceptionPayload) => void;
  [WebSocketChatEvents.NEW_CHAT_CREATED]: (payload: NewChatCreatedPayload) => void;
  [WebSocketChatEvents.ERROR_IN_MESSAGE]: (payload: ErrorInMessagePayload) => void;
  [WebSocketChatEvents.BROADCAST_MESSAGE]: (payload: ReceiveMessagePayload) => void;
  [WebSocketChatEvents.RECEIVE_TEMPORARY_MESSAGE]: (payload: SendMessageInput) => void;
  [WebSocketChatEvents.RECEIVE_NOTIFICATION]: (payload: ReceiveNotificationPayload) => void;
  [WebSocketChatEvents.USER_REMOVED_FROM_CHAT]: (payload: UserRemovedFromChatPayload) => void;
  [WebSocketChatEvents.RECEIVE_MANY_TEMPORARY_MESSAGES]: (payload: SendMessageInput[]) => void;
  [WebSocketChatEvents.SUCCESS_SENDING_MESSAGE]: (payload: SuccessSendingMessagePayload) => void;
}

export interface UserRemovedFromChatPayload {
  chatId: string;
}

export enum ImageOrVideoType {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
}

export interface ImageOrVideoUrlNameAndTypes {
  url: string;
  name: string;
  type: ImageOrVideoType;
}

export interface ChatMessageImageOrVideoData {
  urlNameAndTypes: ImageOrVideoUrlNameAndTypes[];
}

export interface FileUrlAndName {
  url: string;
  name: string;
}

export interface ChatMessageFileData {
  urlAndNames: FileUrlAndName[];
}

export type AcceptedMessageTypeToSubmitMessage =
  | MessageType.FILE
  | MessageType.MESSAGE
  | MessageType.IMAGE_OR_VIDEO;

export type AcceptedMessageDataToSubmitMessage = ChatMessageFileData | ChatMessageImageOrVideoData;

export interface SendMessageInput {
  chatId: string;
  message: string;
  temporaryId: string;
  type: AcceptedMessageTypeToSubmitMessage;
  data?: AcceptedMessageDataToSubmitMessage;
}

export interface SendMessagePayload extends SendMessageInput {
  brandIdFromChat: string;
}
export interface JoinChatPayload {
  chatId: string;
  brandId: string;
}

export interface DisconnectFromChatPayload {
  chatId: string;
  brandId: string;
}

export interface ReceiveNotificationPayload {
  chatId: string;
  message: string;
  updatedAt: Date;
  messageId: string;
  type: MessageType;
  authorName: string;
  authorEmail: string;
}

export interface ReceiveMessagePayload {
  message: ChatMessage;
}

export interface NewChatCreatedPayload {
  newChatId: string;
}

export interface ErrorInMessagePayload {
  temporaryId: string;
  reason?: string;
}

export interface SuccessSendingMessagePayload {
  temporaryId: string;
  message: ChatMessage;
}

export interface ExceptionPayload {
  message: string;
  status: 'error';
  code?: WsErrorsEnum;
}
